import { DateInputController } from './date-input.controller'

const component = {
  templateUrl: '/workflow/components/date-input/date-input.html?$$REVISION$$',
  bindings: {
    field: '<',
    readOnly: '<',
    variations: '<', // space-delimited
    onChange: '&'
  },
  controllerAs: '$ctrl',
  controller: DateInputController
}

export const dateInput = component
